import { useRef, useState } from "react";
import { defaultDateFormatter, modalStyle, modalContentStyle } from "../../Helper/functionHelper.js";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import api from './../../Axios.js';
import * as XLSX from "xlsx";


const ImportAssignment = ({ assetsFun, assets, employees }) => {

    const [showImportBox, setShowImportBox] = useState(false);
    const [importBtnLabel, setImportBtnLabel] = useState('Import valid data');
    const fileInputRef = useRef(null);
    const importBoxRef = useRef(null);
    const importButtonRef = useRef(null);
    const [excelData, setExcelData] = useState([]);
    const [errors, setErrors] = useState([]);
    const [showModal, setShowModal] = useState(false);


    const handleDownloadSample = () => {
        const link = document.createElement('a');
        link.href = `${process.env.REACT_APP_BUILD_PATH}/uploads/sample_asset_assignment_import.xlsx`;
        link.download = 'sample_asset_assignment_import.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleImportClick = () => {
        setShowImportBox((prev) => !prev);
    };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const workbook = XLSX.read(bstr, { type: 'binary' });
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false, dateNF: "yyyy-mm-dd" });

            const [validData, validationErrors] = validateData(jsonData);
            setExcelData(validData);
            setErrors(validationErrors);
            // setShowModal(true);

            // hide import popups
            setShowImportBox((prev) => !prev);

        };

        reader.readAsBinaryString(file);
    };

    const validateData = (data) => {
        const errors = [];

        // Check empty data
        if (!data || data.length === 0) {
            toast.error('No data found in the Excel file.', {
                position: "top-right",
                autoClose: 3000,
            });
            setShowModal(false);
            return [[], []];
        }
        setShowModal(true);

        const validData = data.map((row, index) => {
            const rowErrors = {};

            // Validate Asset
            let matchedAsset = null;
            if (!row["Serial Number"]) {
                rowErrors.asset = "Asset Serial Number is required";
            } else {
                const assetCode = row["Serial Number"].trim();

                matchedAsset = assets.find(
                    (asset) => asset.sr_no === assetCode
                );
                if (!matchedAsset) {
                    rowErrors.asset = "Asset Serial Number doesn't exist";
                } else if (matchedAsset.status === 0) {
                    rowErrors.asset = "Asset is inactive";
                }
            }
            // Validate Employee
            if (!row["Employee Code"]) {
                rowErrors.employee = "Employee Code is required";
            } else {
                const empCode = row["Employee Code"].trim();

                const matchedEmployee = employees.find(
                    (employee) => employee._UserEmployeeID === empCode
                );

                if (!matchedEmployee) {
                    rowErrors.employee = "Employee Code doesn't exist";
                }

                if (
                    matchedAsset &&
                    matchedAsset.assignment_id &&
                    matchedAsset.assigned_to &&
                    matchedAsset.assigned_to._UserEmployeeID !== empCode
                ) {
                    rowErrors.asset = "This Asset is already assigned to someone else";
                }
            }

            // Validate Assigned Date
            if (!row["Assigned Date"]) {
                rowErrors.assigned_date = "Assigned date is required";
            } else {

                // Check DD/MM/YYYY format
                const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;

                if (!dateRegex.test(row["Assigned Date"])) {
                    rowErrors.assigned_date = "Date format must be DD/MM/YYYY";
                } else {

                    const [day, month, year] = row["Assigned Date"].split('/').map(Number);

                    const parsedDate = new Date(year, month - 1, day);

                    // Validate actual calendar date
                    const isValidDate =
                        parsedDate.getFullYear() === year &&
                        parsedDate.getMonth() === month - 1 &&
                        parsedDate.getDate() === day;

                    if (!isValidDate) {
                        rowErrors.assigned_date = "Invalid assigned date";
                    } else {

                        // Compare with today
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        parsedDate.setHours(0, 0, 0, 0);

                        if (parsedDate > today) {
                            rowErrors.assigned_date = "Assigned date cannot be in the future";
                        }
                    }
                }
            }

            // Validate Returned Date
            if (row["Returned Date"]) {

                // Check DD/MM/YYYY format
                const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;

                if (!dateRegex.test(row["Returned Date"])) {
                    rowErrors["Returned Date"] = "Date format must be DD/MM/YYYY";
                } else {

                    const [returnDay, returnMonth, returnYear] = row["Returned Date"]
                        .split('/')
                        .map(Number);

                    const returnedDate = new Date(returnYear, returnMonth - 1, returnDay);

                    // Validate actual calendar date
                    const isValidReturnedDate =
                        returnedDate.getFullYear() === returnYear &&
                        returnedDate.getMonth() === returnMonth - 1 &&
                        returnedDate.getDate() === returnDay;

                    if (!isValidReturnedDate) {
                        rowErrors["Returned Date"] = "Invalid returned date";
                    } else {

                        // Compare with today
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        returnedDate.setHours(0, 0, 0, 0);

                        if (returnedDate > today) {
                            rowErrors["Returned Date"] = "Returned date cannot be in the future";
                        }

                        // Compare with Assigned Date
                        if (row["Assigned Date"]) {

                            const [assignDay, assignMonth, assignYear] = row["Assigned Date"]
                                .split('/')
                                .map(Number);

                            const assignedDate = new Date(
                                assignYear,
                                assignMonth - 1,
                                assignDay
                            );

                            assignedDate.setHours(0, 0, 0, 0);
                            returnedDate.setHours(0, 0, 0, 0);

                            if (returnedDate < assignedDate) {
                                rowErrors["Returned Date"] =
                                    "Returned date cannot be before assigned date";
                            }
                        }
                    }
                }
                if (!row["Return Remark"]) {
                    rowErrors["Return Remark"] = "Return remark is required";
                }
            }

            // Push errors if any for this row
            if (Object.keys(rowErrors).length > 0) {
                errors.push({ row: index + 2, errors: rowErrors }); // Excel rows usually start at 2
            }

            return row;
        });

        return [data, errors];
    };


    const handleImport = async () => {
        try {
            setImportBtnLabel(<FaSpinner />);
            // const validRows = excelData.filter((_, i) => !errors.some(e => e.row === i + 2));

            // if(validRows) {
            //     toast.error('No valid data found', {
            //         position: "top-right",
            //         autoClose: 3000,
            //     });
            // }

            const result = await api.post(`/assets/assignment-import`, excelData, {
                headers: { 'Content-Type': 'application/json' }
            });
            assetsFun();
            setShowModal(false);
            setImportBtnLabel('Import valid data');
            toast.success(result.data.message);
        } catch (err) {
            toast.error(err.response?.data?.error || 'An error occurred. Please try again.', {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };



    return (
        <div>

            {/* import modal */}
            {showModal && (
                <div style={modalStyle}>
                    <div style={modalContentStyle}>
                        <h4>Preview Excel Data</h4>
                        <div style={{ maxHeight: '450px', overflowY: 'auto' }}>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Asset</th>
                                        <th>Employee</th>
                                        <th>Assigned date</th>
                                        <th>Returned date</th>
                                        <th>Return Remark</th>
                                        <th>Errors</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {excelData.map((row, idx) => {
                                        const rowError = errors.find(e => e.row === idx + 2);
                                        return (
                                            <tr key={idx} style={{ backgroundColor: rowError ? '#fdd' : '#dfd' }}>
                                                <td>{row["Serial Number"]}</td>
                                                <td>{row["Employee Code"]}</td>
                                                <td>{row["Assigned Date"]}</td>
                                                <td>{row["Returned Date"]}</td>
                                                <td>{row["Return Remark"]}</td>
                                                <td style={{ color: 'red' }}>{rowError ? Object.values(rowError.errors).join(', ') : ''}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-3 d-flex justify-content-end">
                            <button className="btn btn-success btn-sm me-2" onClick={handleImport}>{importBtnLabel}</button>
                            <button className="btn btn-secondary btn-sm" onClick={() => setShowModal(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}


            <span className="toggle-wrapper">
                <button
                    type="button"
                    id="importEmployees"
                    className="btn btn-success btn-sm ms-2"
                    onClick={handleImportClick}
                    ref={importButtonRef}
                >
                    <span className="material-icons-outlined">file_download</span>
                    <span className="text"> Import Assignment</span>
                </button>
                {showImportBox && (
                    <div className="import-container me-2" style={{ "display": "block" }}>
                        <div
                            className="import-box import-section arrow-top"
                            ref={importBoxRef}
                            style={{ "display": "block" }}>
                            <div className="upload-box" onClick={() => fileInputRef.current.click()}>
                                <h3 id="fileTrigger">
                                    <span className="material-icons-outlined">file_download</span> Click here to import
                                </h3>
                                <div className="supported-files">Supported types: .xls and .csv</div>
                            </div>

                            <div className="form-info-content mt-3">
                                <input
                                    className="form-control"
                                    type="file"
                                    accept=".xlsx, .xls"
                                    ref={fileInputRef}
                                    onClick={() => { fileInputRef.current.value = null; }}
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                />
                                <button
                                    className="btn btn-success mt-2"
                                    onClick={handleDownloadSample}
                                    rel="noopener noreferrer"
                                >
                                    Download Excel Format
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </span>

        </div>
    );
};

export default ImportAssignment;